export const contactsData = {
    email: 'contact@dedale-dev.fr',
    phone: '(+33) 7 56 85 25 04',
    address: '1, chemin de la colline Saint Joseph, 13009 Marseille, France',
    sheetAPI: ''
}